import { defineStore } from 'pinia'

export const useAppStore = defineStore('appdata', {
  state: () => ({
    app: null,
    appdata: null
  })
})
